// format.js - shared number formatters for board-report print blocks.
//
// Deliberately thin: re-exports the *existing* canonical formatters used by the
// live dashboards that back these same endpoints, so a print block renders a
// figure exactly the way the interactive page does (see CLAUDE.md "reuse
// existing components" + "match existing money formatting" guidance).
//
//   - financial-control/summary consumers (StatusBadge, SpendTable,
//     CloudAiSplit, MoMChange, NotesConfidence) -> src/views/cost-control/money.js
//     (used by FinancialControlPage / CalibrationPanel for these exact fields).
//   - forecast-explorer consumers (ForecastTable, BudgetComparison) ->
//     src/views/cost-control/forecast-lab/explorer/format.js (used by
//     SeriesDetail / BudgetDetail for these exact endpoints).
//   - analyzer/attribution consumer (DriverTable) -> the same explorer
//     fmtEurSigned (only signed-euro-delta formatter in the codebase).
import { humanEUR, pct, statusTone } from "../../cost-control/money";
import { fmtEur, fmtEurSigned } from "../../cost-control/forecast-lab/explorer/format";

export { humanEUR, pct, statusTone, fmtEur, fmtEurSigned };

// signedPct renders a signed whole-number percentage from a fraction (e.g. 0.05 -> "+5%",
// -0.03 -> "-3%"). Mirrors the inline signed-percent formatting FinancialControlPage /
// CalibrationPanel each hand-roll at their call sites.
export function signedPct(v) {
  if (v == null || Number.isNaN(Number(v))) return "—";
  const n = Math.round(Number(v) * 100);
  return n >= 0 ? `+${n}%` : `${n}%`;
}

// fmtDate formats an ISO timestamp as an absolute, unambiguous date suitable for a
// once-generated print document (board reports are read later, so "5 min ago"-style
// relative time - see Budgets/formatters.js formatRelativeTime - would be misleading).
export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
}
